import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { DS } from '../../ds';
import { ShareButtons } from './ShareButtons';
import type { BlogArticle } from '../../../data/blogArticles';
interface ArticleDetailProps {
  article: BlogArticle;
  onBack: () => void;
  onHome: () => void;
}
function NavButtons({
  onBack,
  onHome,
  justify = 'flex-start'
}: {
  onBack: () => void;
  onHome: () => void;
  justify?: React.CSSProperties['justifyContent'];
}) {
  return <div style={{
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
    justifyContent: justify
  }} data-id="element-224" data-mp="9ub4d0onokba">
      <button type="button" onClick={onBack} style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '7px',
      background: 'transparent',
      border: `1.5px solid ${DS.color.teal}`,
      color: DS.color.teal,
      padding: '9px 18px',
      borderRadius: DS.radius.pill,
      fontFamily: DS.font.body,
      fontSize: '13px',
      fontWeight: 700,
      cursor: 'pointer',
      transition: `background-color 0.2s ${DS.ease.smooth}`
    }} onMouseEnter={e => {
      e.currentTarget.style.background = DS.color.mint;
    }} onMouseLeave={e => {
      e.currentTarget.style.background = 'transparent';
    }} data-id="element-225" data-mp="euz54e2osfip">
        <ArrowLeftIcon size={15} aria-hidden="true" data-id="element-226" data-mp="k4z35uaqsqlz" />
        Volver a artículos
      </button>

      <button type="button" onClick={onHome} style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '7px',
      background: 'transparent',
      border: `1.5px solid ${DS.color.border}`,
      color: DS.color.body,
      padding: '9px 18px',
      borderRadius: DS.radius.pill,
      fontFamily: DS.font.body,
      fontSize: '13px',
      fontWeight: 700,
      cursor: 'pointer',
      transition: `border-color 0.2s ${DS.ease.smooth}, color 0.2s ${DS.ease.smooth}`
    }} onMouseEnter={e => {
      e.currentTarget.style.borderColor = DS.color.teal;
      e.currentTarget.style.color = DS.color.teal;
    }} onMouseLeave={e => {
      e.currentTarget.style.borderColor = DS.color.border;
      e.currentTarget.style.color = DS.color.body;
    }} data-id="element-227" data-mp="f5m6yixze76q">
        Volver a inicio
      </button>
    </div>;
}
export const ArticleDetail = ({
  article,
  onBack,
  onHome
}: ArticleDetailProps) => {
  return <div data-id="element-228" data-mp="2edm4j8gkxxqn">
      <div style={{
      marginBottom: '32px'
    }} data-id="element-229" data-mp="2eedwm9ayxdc6">
        <NavButtons onBack={onBack} onHome={onHome} data-id="element-230" data-mp="1zo6ha2g9cafp" />
      </div>

      <article style={{
      maxWidth: '760px',
      margin: '0 auto'
    }} data-id="element-231" data-mp="24mhp67mzsava">
        <div style={{
        width: '100%',
        aspectRatio: '16 / 9',
        borderRadius: DS.radius.cardLg,
        overflow: 'hidden',
        marginBottom: '32px',
        background: DS.color.linen
      }} data-id="element-232" data-mp="24mzwq0f3ubii">
          <img src={article.image} alt={article.title} style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }} data-id="element-233" data-mp="1bz8arkpy4m0o" />
        </div>

        <div style={{
        display: 'flex',
        gap: '14px',
        alignItems: 'center',
        flexWrap: 'wrap',
        marginBottom: '18px'
      }} data-id="element-234" data-mp="1l0g2fjxyiols">
          <span style={{
          background: DS.color.mint,
          color: DS.color.tealDeep,
          padding: '4px 10px',
          borderRadius: '8px',
          fontFamily: DS.font.body,
          fontSize: '11px',
          fontWeight: 700
        }} data-id="element-235" data-mp="1uycc07b8xbhs">
            {article.category}
          </span>
        </div>

        <h1 style={{
        fontFamily: DS.font.heading,
        fontSize: 'clamp(2rem, 4.5vw, 2.8rem)',
        fontWeight: 700,
        color: DS.color.ink,
        lineHeight: 1.18,
        letterSpacing: '-0.025em',
        margin: '0 0 20px'
      }} data-id="element-236" data-mp="2dpdeh5bkrp63">
          {article.title}
        </h1>

        <div style={{
        display: 'flex',
        gap: '14px',
        alignItems: 'center',
        flexWrap: 'wrap',
        paddingBottom: '28px',
        borderBottom: `1px solid ${DS.color.border}`,
        marginBottom: '32px',
        fontFamily: DS.font.body,
        fontSize: '14px',
        color: DS.color.muted
      }} data-id="element-237" data-mp="2wsns3se4g2p1">
          <span style={{
          color: DS.color.ink,
          fontWeight: 700
        }} data-id="element-238" data-mp="2dvmmc5cqtyk1">
            Por {article.author}
          </span>
          <span aria-hidden="true" data-id="element-239" data-mp="2iwadcr0z2fe9">·</span>
          <span data-id="element-240" data-mp="2nttr7ptrcq5o">{article.date}</span>
          <span aria-hidden="true" data-id="element-241" data-mp="2nuveqtryn54a">·</span>
          <span data-id="element-242" data-mp="3u9ct5jv8z0xd">{article.readTime} min de lectura</span>
        </div>

        <p style={{
        fontFamily: DS.font.body,
        fontSize: '18px',
        color: DS.color.ink,
        lineHeight: 1.6,
        fontWeight: 600,
        margin: '0 0 8px'
      }} data-id="element-243" data-mp="3u94crhzx1dhf">
          {article.excerpt}
        </p>

        <div className="article-body-full" style={{
        fontFamily: DS.font.body,
        fontSize: '16px',
        lineHeight: 1.8,
        color: DS.color.body
      }} dangerouslySetInnerHTML={{
        __html: article.fullContent
      }} data-id="element-244" data-mp="1imj3m4j4mtfh" />

        <div style={{
        marginTop: '48px',
        paddingTop: '32px',
        borderTop: `1px solid ${DS.color.border}`
      }} data-id="element-245" data-mp="14ve1mvsadp1z">
          <h3 style={{
          fontFamily: DS.font.heading,
          fontSize: '15px',
          fontWeight: 700,
          color: DS.color.ink,
          margin: '0 0 14px'
        }} data-id="element-246" data-mp="uvn40l8fitxo">
            Compartir artículo
          </h3>
          <ShareButtons article={article} data-id="element-247" data-mp="2kbmkyoiahnnv" />
        </div>

        <section style={{
        marginTop: '48px',
        padding: '32px',
        background: 'rgba(0, 170, 212, 0.08)',
        border: `1px solid ${DS.color.aqua}30`,
        borderRadius: DS.radius.cardLg,
        textAlign: 'center'
      }} data-id="element-248" data-mp="2kc5y7rwzvnvk">
          <h3 style={{
          fontFamily: DS.font.heading,
          fontSize: '20px',
          fontWeight: 700,
          color: DS.color.ink,
          margin: '0 0 10px'
        }} data-id="element-249" data-mp="8pubxt5yeuv3">
            ¿Listo para transformar tu práctica?
          </h3>
          <p style={{
          fontFamily: DS.font.body,
          fontSize: '15px',
          color: DS.color.body,
          margin: '0 0 22px'
        }} data-id="element-250" data-mp="169p3n4bcx319">
            Descubre cómo Alinova puede llevar tu clínica al siguiente nivel.
          </p>
          <a href={DS.wa} target="_blank" rel="noopener noreferrer" style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '13px 28px',
          borderRadius: DS.radius.pill,
          background: '#00AAD4',
          boxShadow: '0 8px 26px rgba(0, 170, 212, 0.42)',
          color: '#fff',
          fontFamily: DS.font.body,
          fontSize: '14px',
          fontWeight: 700,
          textDecoration: 'none',
          transition: `background-color 0.22s ${DS.ease.smooth}, box-shadow 0.22s ${DS.ease.smooth}`
        }} onMouseEnter={e => {
          e.currentTarget.style.background = '#0099CC';
          e.currentTarget.style.boxShadow = '0 12px 34px rgba(0, 170, 212, 0.55)';
        }} onMouseLeave={e => {
          e.currentTarget.style.background = '#00AAD4';
          e.currentTarget.style.boxShadow = '0 8px 26px rgba(0, 170, 212, 0.42)';
        }} data-id="element-251" data-mp="3d0y02t4u59vz">
            Solicitar consulta
            <ArrowRightIcon size={15} aria-hidden="true" data-id="element-252" data-mp="1hlpwek8o1znn" />
          </a>
        </section>

        <div style={{
        marginTop: '32px',
        paddingTop: '32px',
        borderTop: `1px solid ${DS.color.border}`
      }} data-id="element-253" data-mp="1mjhszrk9a9y6">
          <NavButtons onBack={onBack} onHome={onHome} justify="center" data-id="element-254" data-mp="1vkppq574j2q5" />
        </div>
      </article>

      <style data-id="element-255" data-mp="20jshwp209egp">
        {`
          .article-body-full h3 {
            font-family: ${DS.font.heading};
            font-size: 18px;
            font-weight: 700;
            color: ${DS.color.tealDeep};
            margin: 28px 0 10px;
          }
          .article-body-full p {
            margin: 0 0 16px;
          }
          .article-body-full ul {
            margin: 0 0 16px;
            padding-left: 20px;
          }
          .article-body-full li {
            margin-bottom: 8px;
          }
        `}
      </style>
    </div>;
};